import { Container, Button } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useForm } from "react-hook-form";
import { Post } from "../../../__generated__/graphql";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useEffect, useMemo, useState } from "react";
import { StagePicker } from "../../../components/StagePicker";
import { CREATE_BOOKING } from "../graphql";
import { BandPicker } from "../../../components/BandPicker";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PageContainer } from "../../../components/PageContainer";
import { ButtonContainer } from "../../../components/ButtonContainer";
import { ErrorField } from "../../../components/ErrorField";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UTCDateTimePicker } from "../../../components/UTCDateTimePicker";
import { DurationButtons } from "../../../components/DurationButtons";
import { GET_EDITIONS } from "../../editions/graphql";
import { GET_ANNOUNCEMENT, GET_ANNOUNCEMENTS } from "../../announcement/graphql";

const schema = yup
  .object({
    band: yup.string().required("A band is required"),
    selectedStartTime: yup.string(),
    // .nonNullable()
    // .required("Start time is required")
    // .test(
    //   "valid-starttime",
    //   "Start time must be before endtime",
    //   (selectedStartTime, ctx) => {
    //     const { selectedEndTime } = ctx.parent;
    //     return dayjs(selectedEndTime).isAfter(dayjs(selectedStartTime));
    //   }
    // ),
    selectedEndTime: yup.string(),
    // .nonNullable()
    // .required("End time is required")
    // .test(
    //   "valid-endtime",
    //   "End time must be after start time",
    //   (selectedEndTime, ctx) => {
    //     const { selectedStartTime } = ctx.parent;
    //     return dayjs(selectedEndTime).isAfter(dayjs(selectedStartTime));
    //   }
    // ),
    stage: yup.string(),
  })
  .required();

interface ICreateBookingFormProps {
  announcementId: string | null;
  festivalId: string
}

export const CreateBookingForm = ({ announcementId, festivalId }: ICreateBookingFormProps) => {
  const navigate = useNavigate();
  const { state: {date} } = useLocation();
  
  const defaultDate =  date ? dayjs(date).set('hour', 12) : null;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    setError,
    trigger,
  } = useForm({ resolver: yupResolver(schema) });
  const [selectedStartTime, setSelectedStartTime] = useState<Dayjs | null>(
    defaultDate || null
  );
  const [selectedEndTime, setSelectedEndTime] = useState<Dayjs | null>(defaultDate || null);
  const [selectedStage, setSelectedStage] = useState<string>();
  const [selectedBand, setSelectedBand] = useState<string>();
  const [createBooking, { loading: updateLoading, error }] = useMutation(
    CREATE_BOOKING,
    {
      refetchQueries: () => {
        const queries: any[] = [
          { query: GET_EDITIONS },
          { query: GET_ANNOUNCEMENT, variables: { id: announcementId } },
          "festivalSingalEdition",
        ];

        if (announcementId) {
          queries.push({
            query: GET_ANNOUNCEMENT,
            variables: { id: announcementId },
          });
        }

        return queries;
      },
      onCompleted: (data) => {
        toast("Added successfully");
        navigate(-1)
      },
      awaitRefetchQueries: true
    }
  );
  const onSubmit = (data: any) => {
    const date = selectedStartTime && new Date(
      Date.UTC(
        selectedStartTime!.year(),
        selectedStartTime!.month(),
        selectedStartTime!.date()
      )
    );

    createBooking({
      variables: {
        date: date?.toISOString(),
        startTime: selectedStartTime?.toISOString(),
        endTime: selectedEndTime?.toISOString(),
        stageId: selectedStage!,
        bandId: selectedBand!,
        announcementId: announcementId,
        editionId: announcementId ? null : festivalId
      },
    });
  };
  const updateEndTime = (value: Dayjs | null) => {
    setValue("selectedEndTime", value?.toString() ?? "");
    trigger("selectedEndTime");
    setSelectedEndTime(value);
  };

  const updateStartTime = (value: Dayjs | null) => {
    setValue("selectedStartTime", value?.toString() ?? "");
    trigger("selectedStartTime");
    setSelectedStartTime(value);
    updateEndTime(value);
  };
  const updateStage = (value: string) => {
    setValue("stage", value?.toString() ?? "");
    trigger("stage");
    setSelectedStage(value!);
  };
  const updateBand = (value: string) => {
    setValue("band", value?.toString() ?? "");
    trigger("band");
    setSelectedBand(value!);
  };
  return (
    <PageContainer title={"Create a booking"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container style={{ flexDirection: "column", display: "flex" }}>
          <BandPicker
            handleChange={(value) => updateBand(value)}
            value={selectedBand}
          />
          <ErrorField additionalStyle={{ marginTop: -6 }}>
            {errors.band?.message}
          </ErrorField>
          {selectedStartTime && (
            <h3>{dayjs(selectedStartTime).format("dddd ll")}</h3>
          )}
          <UTCDateTimePicker
            format="YYYY/MM/DD HH:mm"
            ampm={false}
            label="Start Time"
            value={selectedStartTime}
            onChange={(value: Dayjs | null) => updateStartTime(value)}
          />{" "}
          <ErrorField>{errors.selectedStartTime?.message}</ErrorField>
          <UTCDateTimePicker
            format="YYYY/MM/DD HH:mm"
            ampm={false}
            label="End Time"
            value={selectedEndTime}
            onChange={(value: Dayjs | null) => updateEndTime(value)}
          />
          <DurationButtons
            startTime={selectedStartTime}
            onSelect={(value) => updateEndTime(value)}
          />
          <ErrorField>{errors.selectedEndTime?.message}</ErrorField>
          <StagePicker
            value={selectedStage}
            handleChange={(value) => updateStage(value)}
            festivalId={festivalId}
          />
          <ErrorField additionalStyle={{ marginTop: 6 }}>
            {errors.stage?.message}
          </ErrorField>
          <ButtonContainer>
            <Button type="submit" variant="contained" style={{ marginTop: 18 }}>
              Save
            </Button>
          </ButtonContainer>
        </Container>
      </form>
    </PageContainer>
  );
};
